module.exports = __webpack_public_path__ + "img/404.26c1b286.png";